import { endPoints } from 'api/';
import { getWarehouses } from 'actions/warehouses/';
import { DELETE_WAREHOUSE, UPDATE_WAREHOUSE } from 'actions/types';

/**
  @description Updates warehouse object. This will also act as `delete` action by `disabling` status.
  @param {string} warehouseId
  @param {FormData} payload
  @param {string} companyId Current user's company id.
  @param {boolean} isDeleting If set to true, it will still update the record but UI status will be delete
  @returns Warehouse object
 */
function updateWarehouse(warehouseId, payload, companyId, isDeleting = false) {
  const actionType = isDeleting ? DELETE_WAREHOUSE : UPDATE_WAREHOUSE;

  /**
    @param {Function} dispatch
   */
  return (dispatch) => {
    const action = {
      type: actionType,
      /**
        @param {Function} apiClient
       */
      request: async (apiClient) => {
        const warehouse = await apiClient(
          endPoints.UPDATE_WAREHOUSE,
          payload,
          warehouseId,
        );

        dispatch(getWarehouses({ companyId }));

        return warehouse;
      },
    };

    dispatch(action);
  };
}

export default updateWarehouse;
